// Help > Send feedback limits, shared by the box and the server (server/feedback.ts).
export const FEEDBACK_MIN = 3;
export const FEEDBACK_MAX = 2000;
/** Notes one trainer can send per hour. */
export const FEEDBACK_PER_HOUR = 5;
